module.exports = __webpack_public_path__ + "static/media/camp_small.d7767c7c.jpg";